import { useEffect, useRef, useState } from "react";
import styles from "./Bar.module.scss";
import gsap from "gsap";

const Bar = ({ muted, scale, duration }) => {
  const ref = useRef();
  const timeline = useRef();

  useEffect(() => {
    gsap.set(ref.current, {
      scaleY: scale,
    });

    timeline.current = gsap.timeline({ repeat: -1 });

    timeline.current.to(ref.current, {
      scaleY: 1,
      duration: scale,
    });
    timeline.current.to(ref.current, {
      scaleY: scale,
      duration: scale,
    });
  }, []);

  useEffect(() => {
    if (muted) {
      timeline.current.pause();
      gsap.to(ref.current, {
        scaleY: 0.1,
        duration: 0.5,
      });
    } else {
      gsap.to(ref.current, {
        scaleY: scale,
        duration: 0.2,
        onComplete: () => timeline.current.restart(),
      });
    }
  }, [muted]);

  return <div ref={ref} className={styles.bar}></div>;
};

export default Bar;
